module.exports = __webpack_public_path__ + "static/media/12f75c111a498730e54f83646133536.e583fd9c.jpg";